import { TFunction } from 'i18next'
import { FieldType, IFormConfig } from 'types'
import {
  BankingInformationForm,
  bankingInformationSchema
} from './banking-information-schema'
import { AccountTypeField } from 'components/AccountTypeField'

export const getBankingInformationConfig = (
  t: TFunction
): IFormConfig<BankingInformationForm> => ({
  schema: bankingInformationSchema,
  fields: [
    {
      name: 'bankAccounts.0.bankName',
      label: t('bankingInformation.fields.bankName.label'),
      placeholder: t('bankingInformation.fields.bankName.placeholder'),
      tooltip: t('bankingInformation.fields.bankName.tooltip')
    },
    {
      name: 'bankAccounts.0.routingNumber',
      label: t('bankingInformation.fields.routingNumber.label'),
      placeholder: t('bankingInformation.fields.routingNumber.placeholder'),
      tooltip: t('bankingInformation.fields.routingNumber.tooltip')
    },
    {
      name: 'bankAccounts.0.accountNumber',
      label: t('bankingInformation.fields.accountNumber.label'),
      placeholder: t('bankingInformation.fields.accountNumber.placeholder'),
      tooltip: t('bankingInformation.fields.accountNumber.tooltip')
    },
    {
      name: 'bankAccounts.0.accountType',
      type: FieldType.CUSTOM,
      label: t('bankingInformation.fields.accountType.label'),
      placeholder: t('bankingInformation.fields.accountType.placeholder'),
      tooltip: t('bankingInformation.fields.accountType.tooltip'),
      CustomComponent: AccountTypeField
    }
  ]
})
